import { registerDecorator, type ValidationOptions } from 'class-validator';
import { ISO_DAY_PATTERN } from './deadline.constants';

/** Giorno di calendario `YYYY-MM-DD` che esiste davvero: il solo pattern accetta `2026-13-45`. */
export function isExistingIsoDay(value: unknown): value is string {
  if (typeof value !== 'string' || !ISO_DAY_PATTERN.test(value)) {
    return false;
  }
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
  );
}

export function IsIsoDay(validationOptions?: ValidationOptions): PropertyDecorator {
  return (target, propertyKey) => {
    registerDecorator({
      name: 'isIsoDay',
      target: target.constructor,
      propertyName: String(propertyKey),
      options: {
        message: `${String(propertyKey)} must be an existing date in YYYY-MM-DD format`,
        ...validationOptions,
      },
      validator: { validate: (value: unknown) => isExistingIsoDay(value) },
    });
  };
}
